module.exports = __webpack_public_path__ + "static/img/wheel_bg.468cff4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/millen_images/wheel_bg.png
// module id = O4Wb
// module chunks = 1